import styled from '@emotion/styled';
import { Button, Dropdown, Input, Segment } from 'semantic-ui-react';

export const S = {
  DropdownWrapper: styled.div`
    .ui.dropdown > .menu {
      top: calc(100% + 3px);
    }
  `,
  Dropdown: styled(Dropdown)`
    width: 100%;
  `,
  Input: styled(Input)`
    width: 100%;
    min-width: 0px;
  `,
  MenuHeader: styled(Segment)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
  `,
  GridMenu: styled(Segment)`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.5rem;
    &&&.ui.segment {
      margin-bottom: 0;
    }
  `,
  Button: styled(Button)`
    &.ui.button {
      padding: 0.75rem;
    }
  `,
};
